import { Action } from "redux"

import * as actions from "./actions"
import { IResourceFooter } from "./index"

export const initialState: IResourceFooter = {
    isLoading: false,
    buttons: [],
    itemId: -1,
}

const ACTION_HANDLERS: {
    [action: string]: (state: IResourceFooter, props: Action) => IResourceFooter
} = {
    [actions.INITIALIZE]: (
        state,
        { itemId }: actions.Initialize,
    ): IResourceFooter => ({
        ...state,
        itemId,
    }),

    [actions.REQUEST_STATE_TRANSITION_BUTTONS]: (state): IResourceFooter => ({
        ...state,
        isLoading: true,
    }),

    [actions.CLICK_STATE_TRANSITION_BUTTON]: (state): IResourceFooter => ({
        ...state,
        isLoading: true,
    }),

    [actions.RECEIVE_STATE_TRANSITION_BUTTONS]: (
        state,
        { buttons }: actions.ReceiveStateTransitionButtons,
    ): IResourceFooter => ({
        ...state,
        isLoading: false,
        buttons: buttons,
    }),
}

export default function reducer(
    state = initialState,
    action: Action,
): IResourceFooter {
    const handler: (state: IResourceFooter, action: Action) => IResourceFooter =
        ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
}
